import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative py-12 md:py-16 lg:py-24 overflow-hidden bg-gradient-to-br from-brand-primary to-primary">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-secondary rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <Icon name="Globe" size={20} className="text-accent" />
              <span className="text-sm font-medium">Spanning 45+ Countries Worldwide</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading leading-tight">
              Scale Your Business <br />
              <span className="text-accent underline decoration-accent/30">Globally</span> with Ease
            </h1>

            <p className="text-lg md:text-xl text-gray-200 max-w-2xl">
              Connect with 2,500+ verified international suppliers. Access real-time market intelligence,
              streamlined trade facilitation, and global partnership opportunities.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                className="bg-accent hover:bg-accent/90 text-white"
                iconName="ArrowRight"
                iconPosition="right"
              >
                Explore Suppliers
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white/10"
                iconName="ShieldCheck"
                iconPosition="left"
              >
                Verification Process
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div>
                <div className="text-2xl md:text-3xl font-bold text-accent">2.5k+</div>
                <div className="text-xs md:text-sm text-gray-300">Verified Suppliers</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-accent">45+</div>
                <div className="text-xs md:text-sm text-gray-300">Countries Served</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-accent">$2B+</div>
                <div className="text-xs md:text-sm text-gray-300">Trade Facilitated</div>
              </div>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-8 border-white/10">
              <img
                src="https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80&w=1000"
                alt="Global Logistics and Trade"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>

            {/* Floating Element */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-[240px] z-20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
                  <Icon name="Search" size={24} className="text-success" />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground">Market Intelligence</div>
                  <div className="text-xs text-muted-foreground">Updated in Real-time</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;